export default __webpack_public_path__ + "static/media/gallery_02.90389c16.jpg";